<template>
    <div class="text-center">
        <HeaderView />
        <br>
        <p class="fs-2 fw-bolder"> Hist&oacute;rico de Registro de Usuarios para Consultas de Resultados    </p>
        <br>
        <div class="wrapper">
            <div id="formContent" >
                <!-- Tabs Titles -->
                <form v-on:submit.prevent="obtieneRegConsulta">
                    <div class="container">
                        <div class="row ">
                            <div class="mb-3 mt-3 col-5 text-md-end" >
                                <span class="h3 ">Fecha:</span>
                            </div>
                            <div class="mb-3 mt-3 col-6 text-md-start">
                                <input type="date" id="FechaForm" v-model="fechas" name="FechaForm" min="min" max="max" locale="es" />
                            </div>
                            <div class="mb-1 mt-1 col-1"></div>
                        </div>
                        <div class="row ">
                            <div class="mb-3 mt-3 col-5 text-md-end">
                                <span class="h3">Usuario:</span>
                            </div>
                            <div class="mb-3 mt-3 col-6 text-md-start" >
                                <b-form-select class="h5 " id="select-usuario" v-model="usuario_" :options="usuarios" required ></b-form-select>
                            </div>
                        </div>
                    </div>
                    <input type="submit" class="fadeIn fourth" value="Mostrar">
                </form>
            </div>
        </div>
        <br><br>
        <div class="container table-responsive=lg">
        <table class="table table-sm table-bordered table-striped table-hover">
            <thead>
                <tr>
                    <th scope="col" rowspan="2" valign="middle">Nro</th>
                    <th scope="col" rowspan="2" valign="middle">Fecha</th>
                    <th scope="col" rowspan="2" valign="middle">Hora</th>
                    <th scope="col" rowspan="2" valign="middle">Usuario</th>
                    <th scope="col" colspan="7">Desde</th>
                </tr>
                <tr>
                    <th scope="col">Direccion IP</th>
                    <th scope="col">Ciudad</th>
                    <th scope="col">Pais</th>
                    <th scope="col">Cod Pais</th>
                    <th scope="col">VPN</th>
                    <th scope="col">Proveedor Servicio</th>
                    <th scope="col">Tipo Conexion</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="lista in ListaConsulta" :key="lista.row_number" v-on:click = "prueba(lista.id_hist_regconsulta);">
                    <th scope="row">{{ lista.row_number }}</th>
                    <td>{{ lista.fecha_regconsult }}</td>
                    <td>{{ lista.hora_regconsult }}</td>
                    <td>{{ lista.username }}</td>
                    <td>{{ lista.tdireccionip_regconsult }}</td>
                    <td>{{ lista.tciudad_regconsult }}</td>
                    <td>{{ lista.tpais_regconsult }}</td>
                    <td>{{ lista.tcod_pais_regconsult }}</td>
                    <td>{{ lista.bisvpm }}</td>
                    <td>{{ lista.tisp }}</td>
                    <td>{{ lista.ttipo_conexion }}</td>
                </tr>
            </tbody>
        </table>
        <br><br><br>
        </div>
        <FooterView />
        <br><br><br>
    </div>
</template>

<script>
    import HeaderView from '@/components/HeaderView.vue';
    import FooterView from '@/components/FooterView.vue';
    import constantes from '../../components/ConfigView.vue';
    import funcionesJS from '../../libs/funciones';
    import axios from 'axios';

    export default{
        name: "HistRegistroConsulta",
        components: {
            HeaderView,
            FooterView
        },
        data() {
            const now = new Date();
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
            // 15th two months prior
            const minDate = new Date(today);
            minDate.setMonth(minDate.getMonth() - 2);
            minDate.setDate(15);
            // 15th in two months
            const maxDate = new Date(today);
            maxDate.setMonth(maxDate.getMonth() + 2);
            maxDate.setDate(15);
            return {
                usuario_: null,
                fechas: '',
                min: minDate,
                max: maxDate,
                usuarios: [
                    { value: null, text: 'Seleccione un Usuario' }
                ],
                ListaConsulta: null
            }
        },
        methods: {
            obtieneRegConsulta(){
                if (this.fechas==''){
                    alert('La Fecha, NO puede estar vacio');
                    return;
                } else{
                    let url = `${constantes.API_LOCATION}/api/hist/getRegConsulta/${this.usuario_}/'${this.fechas}'`;
                    axios.get(url).then(data => {
                        this.ListaConsulta = data.data;
                    });
                }
            },
        },
        mounted: async function(){
            let url = `${constantes.API_LOCATION}/api/hist/getUsuarios/true`;
            axios.get(url).then(data => {
                data.data.forEach(e => {
                    //Se agregan los datos de los usuarios a lo que mostrara el combo de usuarios 
                    this.usuarios = this.usuarios.concat({ value: `${e.id_usuario}`, text: `${e.username}` });
                    //Ordenamos los datos dentro del array por valor
                    this.usuarios.sort((a, b) => {
                        if(a.value < b.value){
                            return -1;
                        } else if(a.value > b.value){
                            return 1;
                        } else {
                            return 0;
                        }
                    });
                })
            });
            this.fechas = await funcionesJS.requestFECHAcontrolDATE('');
        }
}
</script>

<style scoped>
/* BASIC */
html {
    background-color: #2bb062;
}

body {
    font-family: "Poppins", sans-serif;
    height: 100vh;
}

a {
    color: #0d5e35;
    display:inline-block;
    text-decoration: none;
    font-weight: 400;
}

h2 {
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    text-transform: uppercase;
    display:inline-block;
    margin: 40px 8px 10px 8px; 
    color: #cccccc;
}

/* STRUCTURE */
.wrapper {
    display: flex;
    align-items: center;
    flex-direction: column; 
    justify-content: center;
    width: 100%;
    min-height: 100%;
    padding: 20px;
}

#formContent {
    -webkit-border-radius: 10px 10px 10px 10px;
    border-radius: 10px 10px 10px 10px;
    background: #fff;
    padding: 20px;
    width: 85%;
    max-width: 650px;
    position: relative;
    padding: 0px;
    -webkit-box-shadow: 0 30px 60px 0 rgba(0,0,0,0.3);
    box-shadow: 0 30px 60px 0 rgba(0,0,0,0.3);
    text-align: center;
}

/* TABS */
h2.inactive {
    color: #cccccc;
}

h2.active {
    color: #0d0d0d;
    border-bottom: 2px solid #5fbae9;
}

/* FORM TYPOGRAPHY*/
input[type=button], input[type=submit], input[type=reset]  {
    background-color: #136228;
    border: none;
    color: white;
    padding: 15px 80px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    text-transform: uppercase;
    font-size: 13px;
    -webkit-box-shadow: 0 10px 30px 0 rgba(95,186,233,0.4);
    box-shadow: 0 10px 30px 0 rgba(95,186,233,0.4);
    -webkit-border-radius: 5px 5px 5px 5px;
    border-radius: 5px 5px 5px 5px;
    margin: 5px 20px 40px 20px;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
}

input[type=button]:hover, input[type=submit]:hover, input[type=reset]:hover  {
    background-color: #27a854;
}

input[type=button]:active, input[type=submit]:active, input[type=reset]:active  {
    -moz-transform: scale(0.95);
    -webkit-transform: scale(0.95);
    -o-transform: scale(0.95);
    -ms-transform: scale(0.95);
    transform: scale(0.95);
}

input[type=text] {
    background-color: #f6f6f6;
    border: none;
    color: #0d0d0d;
    padding: 15px 32px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    margin: 5px;
    width: 85%;
    border: 2px solid #f6f6f6;
    -webkit-transition: all 0.5s ease-in-out;
    -moz-transition: all 0.5s ease-in-out;
    -ms-transition: all 0.5s ease-in-out;
    -o-transition: all 0.5s ease-in-out;
    transition: all 0.5s ease-in-out;
    -webkit-border-radius: 5px 5px 5px 5px;
    border-radius: 5px 5px 5px 5px;
}

input[type=text]:focus {
    background-color: #fff;
    border-bottom: 2px solid #5fbae9;
}

input[type=text]:placeholder {
    color: #cccccc;
}

.fadeIn {
    opacity:1;
    -webkit-animation:fadeIn ease-in 1;
    -moz-animation:fadeIn ease-in 1;
    animation:fadeIn ease-in 1;

    -webkit-animation-fill-mode:forwards;
    -moz-animation-fill-mode:forwards;
    animation-fill-mode:forwards;

    -webkit-animation-duration:1s;
    -moz-animation-duration:1s;
    animation-duration:1s;
}

.fadeIn.first {
    -webkit-animation-delay: 0.4s;
    -moz-animation-delay: 0.4s;
    animation-delay: 0.4s;
}

.fadeIn.second {
    -webkit-animation-delay: 0.6s;
    -moz-animation-delay: 0.6s;
    animation-delay: 0.6s;
}

.fadeIn.third {
    -webkit-animation-delay: 0.8s;
    -moz-animation-delay: 0.8s;
    animation-delay: 0.8s;
}
.fadeIn.fourth {
    -webkit-animation-delay: 1s;
    -moz-animation-delay: 1s;
    animation-delay: 1s;
}
/* Simple CSS3 Fade-in Animation */
.underlineHover:after {
    display: block;
    left: 0;
    bottom: -10px;
    width: 0;
    height: 2px;
    background-color: #56baed;
    content: "";
    transition: width 0.2s;
}
.underlineHover:hover {
    color: #0d0d0d;
}
.underlineHover:hover:after{
    width: 100%;
}

/* OTHERS */
*:focus {
    outline: none;
} 
</style>



